const module = { name: 'shared/offerBanner.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as offerModal } from 'swug-fdRequire-call:shared/offerModal';

function run() {
    checkDependencies(module.name, debugLog);
    offerModal.init();
}
run();
export default module.exports;